const runScriptOnReady = require('public/js/lib/run-script-on-ready');
const csrf = require('public/js/lib/csrf');

function productSubscription() {
	if (typeof rp$ === 'undefined' || !rp$) {
		return;
	}

	const $waitlistModal = rp$('#backorderWaitlistModal');
	const $waitlistSuccessModal = rp$('#backorderWaitlistSuccessModal');
	const $waitlistForm = rp$('#backorder-waitlist-form');
	const $emailInput = rp$('#waitlist-email');
	const $messageDiv = rp$('#waitlist-message');
	
	let lastSubmittedEmail = '';
	
	function setModalBackground($modal) {
		if ($modal?.length > 0) {
			const $modalContent = $modal.find('.modal-content');
			if ($modalContent.length > 0) {
				$modalContent.css('background-color', '#fff');
			}
		}
	}
	
	setModalBackground($waitlistModal);
	setModalBackground($waitlistSuccessModal);

	rp$(document).on('click', '#backorder-waitlist-trigger', function () {
		const $email = rp$('#waitlist-email');
		$email.val('');
		$email.removeClass('has-value');
		rp$('#waitlist-message').hide().removeClass('error success').text('');
		rp$('#backorder-waitlist-form').removeClass('has-error');
		
		// Re-enable the submit button when opening the modal
		rp$('#waitlist-submit-btn')
			.prop('disabled', false)
			.removeClass('loading');
		
		setTimeout(function() {
			const emailElement = document.getElementById('waitlist-email');
			if (emailElement) {
				emailElement.focus();
			}
		}, 600);
	});
	
	
	rp$(document).on('shown.bs.modal', '#backorderWaitlistModal', function () {
		const $email = rp$('#waitlist-email');
		if ($email?.length > 0) {
			setTimeout(function() {
				const emailElement = $email[0];
				if (emailElement) {
					emailElement.focus();
				}
			}, 100);
		}
		const $modal = rp$(this);
		setModalBackground($modal);
		
		// Re-enable the submit button when modal is shown
		rp$('#waitlist-submit-btn')
			.prop('disabled', false)
			.removeClass('loading');
		
		const $closeButton = $modal.find('.waitlist-submit-button');
		const $modalTitle = $modal.find('.modal-title');
		if ($closeButton.length > 0 && $modalTitle.length > 0) {
			function applyTitleColor() {
				const buttonBgColor = window.getComputedStyle($closeButton[0]).backgroundColor;
				if (buttonBgColor && buttonBgColor !== 'rgba(0, 0, 0, 0)' && buttonBgColor !== 'transparent' && buttonBgColor !== 'rgb(0, 0, 0)') {
					const currentStyle = $modalTitle.attr('style') || '';
					const cleanedStyle = currentStyle.replace(/color\s*:[^;]+;?/gi, '');
					const newStyle = cleanedStyle + ' color: ' + buttonBgColor + ' !important;';
					$modalTitle.attr('style', newStyle);
				}
			}
			
			applyTitleColor();
			setTimeout(applyTitleColor, 5);
			setTimeout(applyTitleColor, 50);
			setTimeout(applyTitleColor, 200);
			setTimeout(applyTitleColor, 500);
		}
	});
	
	
	if (typeof $ !== 'undefined' && $ !== rp$) {
		$(document).on('shown.bs.modal', '#backorderWaitlistModal', function() {
			const emailElement = document.getElementById('waitlist-email');
			if (emailElement) {
				setTimeout(function() {
					emailElement.focus();
				}, 100);
			}
		});
	}

	rp$(document).on('click', '#backorderWaitlistModal .close, .modal-backdrop', function () {
		const $waitlistForm = rp$('#backorder-waitlist-form');
		if ($waitlistForm.length) {
			$waitlistForm[0].reset();
			$waitlistForm.removeClass('has-error');
		}

		if ($emailInput.length) {
			$emailInput.val('');
			$emailInput.removeClass('has-value');
		}

		if ($messageDiv.length) {
			$messageDiv.hide().removeClass('error success').text('');
		}

		rp$('#waitlist-submit-btn')
			.prop('disabled', false)
			.removeClass('loading');

		lastSubmittedEmail = '';
	});
	
	function updateLabelState() {
		const $input = rp$('#waitlist-email');
		if ($input?.length > 0) {
			const value = $input.val().trim();
			if (value) {
				$input.addClass('has-value');
			} else {
				$input.removeClass('has-value');
			}
		}
	}
	
	function isValidEmailFormat(email) {
		if (!email || typeof email !== 'string') {
			return false;
		}
		
		email = email.trim();
		
		if (email.length === 0 || email.length > 128) {
			return false;
		}
		
		const atIndex = email.indexOf('@');
		if (atIndex === -1 || atIndex === 0 || atIndex === email.length - 1) {
			return false;
		}
		
		const localPart = email.substring(0, atIndex);
		const domainPart = email.substring(atIndex + 1);
		
		const localPartRegex = /^[a-zA-Z0-9._+-]+$/;
		if (!localPartRegex.test(localPart)) {
			return false;
		}
		
		if (localPart.startsWith('.') || localPart.endsWith('.') || localPart.startsWith('-') || localPart.endsWith('-')) {
			return false;
		}
		
		if (localPart.includes('..')) {
			return false;
		}
		
		if (domainPart.length === 0) {
			return false;
		}
		
		if (domainPart.startsWith('.')) {
			return false;
		}
		
		if (!domainPart.includes('.')) {
			return false;
		}
		
		const lastDotIndex = domainPart.lastIndexOf('.');
		const tld = domainPart.substring(lastDotIndex + 1);
		if (tld.length < 2 || !/^[a-zA-Z0-9-]+$/.test(tld)) {
			return false;
		}
		
		const domainPartRegex = /^[a-zA-Z0-9.-]+$/;
		if (!domainPartRegex.test(domainPart)) {
			return false;
		}
		
		if (domainPart.includes('..')) {
			return false;
		}
		
		return true;
	}
	
	if ($emailInput?.length > 0) {
		$emailInput.on('input change', function() {
			updateLabelState();
			const currentEmail = rp$(this).val().trim();
			if (currentEmail !== lastSubmittedEmail && $messageDiv.hasClass('error')) {
				$messageDiv.hide().removeClass('error').text('');
				$waitlistForm.removeClass('has-error');
			}
		});

		$emailInput.on('focus blur', updateLabelState);

		if ($emailInput.val()) {
			updateLabelState();
		}
	}
	

	rp$(document).on('shown.bs.modal', '#backorderWaitlistSuccessModal', function () {
		const $modal = rp$(this);
		setModalBackground($modal);
		
		const $closeButton = $modal.find('.waitlist-submit-button');
		const $modalTitle = $modal.find('.modal-title');
		if ($closeButton.length > 0 && $modalTitle.length > 0) {
			function applyTitleColor() {
				const buttonBgColor = window.getComputedStyle($closeButton[0]).backgroundColor;
				if (buttonBgColor && buttonBgColor !== 'rgba(0, 0, 0, 0)' && buttonBgColor !== 'transparent' && buttonBgColor !== 'rgb(0, 0, 0)') {
					const currentStyle = $modalTitle.attr('style') || '';
					const cleanedStyle = currentStyle.replace(/color\s*:[^;]+;?/gi, '');
					const newStyle = cleanedStyle + ' color: ' + buttonBgColor + ' !important;';
					$modalTitle.attr('style', newStyle);
				}
			}
			
			applyTitleColor();
			setTimeout(applyTitleColor, 5);
			setTimeout(applyTitleColor, 50);
			setTimeout(applyTitleColor, 200);
			setTimeout(applyTitleColor, 500);
		}
	});

	
	rp$(document).on('click', '#waitlist-submit-btn', function(e) {
		e.preventDefault();
		e.stopPropagation();
		
		const $submitBtn = rp$(this);
		const $waitlistModal = rp$('#backorderWaitlistModal');
		const $waitlistSuccessModal = rp$('#backorderWaitlistSuccessModal');
		const $waitlistForm = rp$('#backorder-waitlist-form');
		const $messageDiv = rp$('#waitlist-message');
		
		$submitBtn.prop('disabled', true).addClass('loading');
		
		const email = rp$('#waitlist-email').val().trim();
		const data = {
			mpn_stripped: rp$('.product-purchase-module').data('sku-stripped') || '',
			brand_key: rp$('.product-purchase-module').data('catalog') || '',
			email: email,
		};
		
		const csrfToken = csrf.getToken();
		if (!csrf.isValidToken(csrfToken)) {
			console.error('Product Subscription: CSRF token not available');
			$waitlistForm.addClass('has-error');
			$messageDiv.addClass('error').text('Security token missing. Please refresh the page and try again.').show();
			$submitBtn.prop('disabled', false).removeClass('loading');
			return false;
		}
		
		const csrfData = csrf.getCsrfRequestData(csrfToken);
		csrfData.forEach(function(csrfItem) {
			Object.assign(data, csrfItem);
		});
		
		if (email !== lastSubmittedEmail) {
			$messageDiv.hide().removeClass('error').text('');
		}
		
		if (!data.email) {
			$waitlistForm.addClass('has-error');
			$messageDiv.addClass('error').text('Please enter your email address').show();
			$submitBtn.prop('disabled', false).removeClass('loading');
			lastSubmittedEmail = '';
			return false;
		}
		
		if (!isValidEmailFormat(data.email)) {
			$waitlistForm.addClass('has-error');
			$messageDiv.addClass('error').text('Please enter a valid email address').show();
			$submitBtn.prop('disabled', false).removeClass('loading');
			lastSubmittedEmail = '';
			return false;
		}
		
		lastSubmittedEmail = email;
		
		const ajaxFn = (typeof $ajax !== 'undefined' ? $ajax : null) ?? rp$?.ajax ?? null;
		
		if (!ajaxFn) {
			console.error('Product Subscription: AJAX function not available');
			$waitlistForm.addClass('has-error');
			$messageDiv.addClass('error').text('An error occurred. Please try again later.').show();
			$submitBtn.prop('disabled', false).removeClass('loading');
			return false;
		}
		
		ajaxFn({
			type: 'POST',
			url: '/ajax/backorder-waitlist/subscribe',
			dataType: 'json',
			contentType: 'application/json',
			data: JSON.stringify(data),
			success: function(response) {
				if (response?.status === 'ok') {
					// Re-enable the submit button on success (before showing success modal)
					$submitBtn.prop('disabled', false).removeClass('loading');
					
					// Don't overwrite the success message - use the one from the template
					// The template already has the correct message set from product_subscription.success_message
					
					function showSuccessModal() {
						if ($waitlistSuccessModal?.length > 0) {
							setModalBackground($waitlistSuccessModal);
							$waitlistSuccessModal.modal('show');
						}
					}
					
					if ($waitlistModal?.length > 0) {
						const isModalShown = $waitlistModal.hasClass('show') || $waitlistModal.is(':visible') || $waitlistModal.hasClass('in');
						
						if (isModalShown) {
							let successModalShown = false;
							
							$waitlistModal.one('hidden.bs.modal', function() {
								if (!successModalShown) {
									successModalShown = true;
									showSuccessModal();
								}
							});
							
							setTimeout(function() {
								if (!successModalShown) {
									successModalShown = true;
									showSuccessModal();
								}
							}, 500);
							
							$waitlistModal.modal('hide');
						} else {
							showSuccessModal();
						}
					} else {
						showSuccessModal();
					}
				} else {
					const message = response?.message ?? '';
					if (message) {
						$waitlistForm.addClass('has-error');
						$messageDiv.addClass('error').text(message).show();
					}
					$submitBtn.prop('disabled', false).removeClass('loading');
				}
			},
			error: function(xhr) {
				let errorMessage = '';
				try {
					const response = JSON.parse(xhr.responseText);
					errorMessage = response?.message ?? '';
				} catch (e) {
				}
				if (errorMessage) {
					$waitlistForm.addClass('has-error');
					$messageDiv.addClass('error').text(errorMessage).show();
				}
				$submitBtn.prop('disabled', false).removeClass('loading');
			}
		});
		
		return false;
	});
	
	rp$(document).on('submit', '#backorder-waitlist-form', function(e) {
		e.preventDefault();
		e.stopPropagation();
		return false;
	});
}

rp$.fn.product_subscription = productSubscription;

runScriptOnReady('product_subscription', productSubscription);
